import React, { useEffect, useState } from 'react';
import { Grid, Card, CardContent, Typography, CircularProgress, IconButton, Snackbar, Alert } from '@mui/material';
import { Task } from '../../model/task.model';
import { useDispatch, useSelector } from "react-redux";
import { getAllTaskFromServer, getTasksByUserId } from "../../api/task.api";
import { setAllTask } from "../../Redux/tasx/taskAction";
import { styled } from '@mui/material/styles';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { pink } from '@mui/material/colors';
import { UpDateTask } from "../../api/task.api";
import Rtl from '../rtl/rtl';
import { Project } from '../../model/project.model';
import { getProject } from '../../api/project.api';
import { setAllProject } from '../../Redux/Project/projectAction';
import { getUsers } from '../../api/user.api';
import { setAllUsers } from '../../Redux/User/userAction';
import { User } from '../../model/user.model';

const CardContainer = styled(Grid)({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: '16px',
  padding: '16px',
});

const StyledCard = styled(Card)(({ theme }) => ({
  width: '300px',
  borderRadius: '12px',
  boxShadow: `0 4px 8px rgba(0, 0, 0, 0.1)`,
  transition: 'transform 0.3s, box-shadow 0.3s',
  overflow: 'hidden',
  '&:hover': {
    transform: 'scale(1.05)',
    boxShadow: `0 8px 16px rgba(0, 0, 0, 0.2)`,
  },
}));

const CardHeader = styled('div')(({ theme }) => ({
  backgroundColor: 'red',
  color: theme.palette.common.white,
  padding: '8px 16px',
  borderRadius: '12px 12px 0 0',
  textAlign: 'center',
}));

const CardContentStyled = styled(CardContent)({
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});

const IconContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginBottom: '8px',
});


const calculateRemainingDays = (startDateInput: string | Date, expectedDays: number): number => {
  const startDate = typeof startDateInput === 'string' ? new Date(startDateInput) : startDateInput;
  const now = new Date();


  const endDate = new Date(startDate);
  endDate.setDate(endDate.getDate() + expectedDays);

  const diffMs = endDate.getTime() - now.getTime();
  const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

  return diffDays >= 0 ? diffDays : 0;
};
const calculateOverdueDays = (startDateInput: string | Date, expectedDays: number): number => {
  const startDate = typeof startDateInput === 'string' ? new Date(startDateInput) : startDateInput;
  const now = new Date();

  const endDate = new Date(startDate);
  endDate.setDate(endDate.getDate() + expectedDays);

  const diffMs = now.getTime() - endDate.getTime();
  const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

  return diffDays > 0 ? diffDays : 0;
};


const convertDateTimeToDate = (dateInput: string | Date): string => {
  if (!dateInput) return '';

  let date: Date;

  if (typeof dateInput === 'string') {
    date = new Date(dateInput);
  } else {
    date = dateInput;
  }

  if (isNaN(date.getTime())) return '';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${day}/${month}/${year}`;
};

const UrgentTasksCard: React.FC = () => {
  const tasksState = useSelector((state: { Task: { allTask: Task[] } }) => state.Task.allTask);
  const projectState = useSelector((state: { Project: { allProject: Project[] } }) => state.Project.allProject);

  const [project, setProject] = useState<Project[]>([]);
  const dispatch = useDispatch();
  const [filteredTasks, setFilteredTasks] = useState<Task[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
  const [snackbarMessage, setSnackbarMessage] = useState<string>('');
  const [users, setUsers] = useState<User[]>([])
  const [tasks, setTasks] = useState<Task[]>([]);
  const currentUser = useSelector((state: { user: { currentUser: any } }) => state.user.currentUser);

  const getUserFromSession = () => {
    return sessionStorage.getItem('userId') || '';
  };

  useEffect(() => {
    fetchDataTask();
    fetchDataProject();
    fetchDataUser();
  }, []);

  const fetchDataUser = async () => {
    const resAllUsers = await getUsers();
    dispatch(setAllUsers(resAllUsers));
    setUsers(resAllUsers);
  };

  const fetchDataProject = async () => {
    try {
      let data;
      if (projectState.length) {
        data = projectState;
      } else {
        const resAllproject = await getProject();
        data = resAllproject.data || resAllproject;
        dispatch(setAllProject(data));
      }
      setProject(data);
    }
    catch (error) {
      console.error('Error fetching projects:', error);
    }
  };

  const fetchDataTask = async () => {
    try {
      let res;
      const userId = sessionStorage.getItem("userId");
      const userRole = sessionStorage.getItem("userType");
      if (userRole === "מנהל") {
        res = await getAllTaskFromServer();
      } else {
        res = await getTasksByUserId(userId);
      }
      const overdueTasks = res.filter(task => {
        if (!task.expectedDurationInDays || !task.startDate) return false;
        const remainingDays = calculateRemainingDays(task.startDate, task.expectedDurationInDays);
        return remainingDays <= 0;
      });


      setFilteredTasks(overdueTasks);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching tasks:", error);
      setLoading(false);
    }
  };



  const handleAssignTask = async (taskId: string) => {
    try {
      const userId = getUserFromSession();
      if (!userId) {
        setSnackbarMessage('User is not logged in');
        setSnackbarOpen(true);
        return;
      }

      const taskToUpdate = filteredTasks.find(task => task.taskId === taskId);
      if (!taskToUpdate) {
        setSnackbarMessage('Task not found');
        setSnackbarOpen(true);
        return;
      }

      const updatedTask = { ...taskToUpdate, assignedTo: userId };
      await UpDateTask(updatedTask);

      setFilteredTasks(prevTasks =>
        prevTasks.map(task => task.taskId === taskId ? updatedTask : task)
      );

      setSnackbarMessage('Task assigned successfully');
      setSnackbarOpen(true);
    } catch (error) {
      setSnackbarMessage('Error assigning task');
      setSnackbarOpen(true);
    }
  };

  if (loading) {
    return <div style={{ textAlign: 'center' }}><CircularProgress /></div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <>
      <Rtl>
        <CardContainer container spacing={2}>
          {filteredTasks.map((task) => {
            const remainingDays = calculateRemainingDays(task.startDate, task.expectedDurationInDays);

            return (
              <Grid item key={task.taskId}>
                <StyledCard>
                  <CardHeader>
                    <Typography variant="h6">{task.taskName}</Typography>
                  </CardHeader>
                  <CardContentStyled>
                    <IconContainer style={{ textAlign: 'right', direction: 'rtl' }}>
                      <AccessAlarmIcon style={{ color: pink[500] }} />
                      <Typography variant="body2" style={{ textAlign: 'right' }}>
                        <strong>אחראית משימה: </strong>
                        {users
                          .filter(user => user.id === task.assignedTo)
                          .map(user => (
                            <div key={user.id}>
                              {user.firstName} {user.lastName}
                            </div>
                          ))}
                      </Typography>
                    </IconContainer>

                    <Typography variant="body2" style={{ textAlign: 'right' }}>
                      <strong>תאור: </strong> {task.description || 'אין תאור'}
                    </Typography>
                    <Typography variant="body2" style={{ textAlign: 'right' }}>
                      {project
                        .filter(proj => proj.projectId === task.projectId)
                        .map(proj => (
                          <div key={proj.projectId}>
                            <strong>פרויקט: </strong>{proj.businessName}
                          </div>
                        ))}
                    </Typography>
                    <Typography variant="body2" style={{ textAlign: 'right' }}>
                      <strong>שם קטגוריה: </strong> {task.taskCategory.categoryName}
                    </Typography>
                    <Typography variant="body2" style={{ textAlign: 'right' }}>
                      <strong>סטטוס: </strong> דחוף
                    </Typography>
                    <Typography variant="body2" style={{ textAlign: 'right' }}>
                      <strong>תאריך התחלה: </strong> {convertDateTimeToDate(task.startDate)}
                    </Typography>
                    <Typography variant="body2" style={{ textAlign: 'right' }}>
                      <strong>משך צפוי (ימים): </strong> {task.expectedDurationInDays}
                    </Typography>
                    <Typography variant="body2" style={{ textAlign: 'right' }}>
                      <strong>ימי איחור: </strong> {calculateOverdueDays(task.startDate, task.expectedDurationInDays)} ימים
                    </Typography>

                  </CardContentStyled>
                </StyledCard>
              </Grid>
            );
          })}
        </CardContainer>
        <Snackbar open={snackbarOpen} autoHideDuration={4000} onClose={() => setSnackbarOpen(false)}>
          <Alert severity="info" onClose={() => setSnackbarOpen(false)}>{snackbarMessage}</Alert>
        </Snackbar>
      </Rtl>
    </>
  );
};

export default UrgentTasksCard;
